var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expositionCom powerStation"},[_c('div',{staticClass:"com-left flex justify-between"},[_c('left-1'),_c('left-2')],1),_c('div',{staticClass:"com-main flex justify-between"},[_c('goBack'),_c('center',{on:{"backData":_vm.backData}})],1),_c('div',{staticClass:"com-right"},[_c('right-1')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }